import React from 'react';
import SecondImage from "../assets/AboutImage4.jpg";

function About() {
  return (
    <section>
      <div className="mx-auto w-full">
        <div className="grid gap-6 sm:gap-6 md:grid-cols-2 ">
          {/* Left Column (Text and Buttons) */}
          <div className="flex flex-col items-start gap-2 md:py-24 md:px-24 max-w-[600px] p-4">
            <div className="flex items-center rounded-md py-1">
              <p className="text-sm uppercase mb-12">ABOUT US</p>
            </div>
            <h4 className="mb-6 text-2xl font-semibold md:text-3xl md:mb-8 uppercase">
            Empowering <span className='italic text-black bg-[#CFF098]'>Women Entrepreneurs </span> with Powerful Online <span className='italic text-black bg-[#CFF098]'>Presence.</span> 
            </h4>
            <p className="text-sm text-white sm:text-xl">
            We specialize in crafting custom websites and SEO strategies tailored for women-run small and medium businesses. Our goal is to enhance your online visibility and attract the clients you deserve. If you're looking to <span className='italic'>hire web designer</span> expertise, you've come to the right place.
            <br/>
            <br/>
            With over 200+ businesses experiencing growth through our digital strategies, we understand the unique needs of women entrepreneurs. Many have sought a <span className='italic'>professional web design company</span> like ours.
            </p>
            <p className='mt-6 mb-6 text-xl italic uppercase'>We’ve got your back. If you <span className='italic'>need a website designer</span>, we are here to help.</p>

            <div className="flex flex-col gap-4 font-regular sm:flex-row">
              <a href="/about" className="flex rounded-full items-center gap-4 bg-[#CFF098] px-8 py-2 text-black hover:opacity-60 text-sm">
                <p>LEARN MORE ABOUT US →</p>
              </a>
            </div>
          </div>

          {/* Right Column (Image) */}
          <div className="relative w-full h-[]">
            <img
              src={SecondImage}
              alt="women using a laptop outdoors - Her Growth Co"
              className="absolute top-0 right-0 w-auto h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;